var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"list"},[_c('hight-light',{attrs:{"text":_vm.name,"bg-text":_vm.name,"is-bg":true}}),_c('img',{attrs:{"src":_vm.image,"alt":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }